<template>
	<div class='page'>
		<pageTitle title='追加点评' @rightHandler='publish' :showRight='true' rightTitle='发布' />
		<div class='hotelMsg whiteBg'>
			<img src='../../../static/search/noImg.jpg' />
			<div class='right'>
				<div class='name'>{{append.HotelName}}</div>
				<div class='address'>
					<mu-icon value="room" color="#A5A5A5" :size='13' />
					{{append.Address}}
				</div>
				<div class='desc'>入住：{{append.CheckInTime}}</div>
				<div class='desc'>离店：{{append.CheckOutTime}}</div>
				<div class='desc'>房型：{{append.RoomType}}</div>
			</div>
		</div>
		<div class='text'>
			<inputArea v-model='content' height='2.15rem' hitMsg='请在此处填写追评' />
		</div>
		<mu-toast v-if="toast" id="alertline" v-bind:message="hintMes" @close="hideToast" />
	</div>
</template>

<style lang="less" scoped>
	.hotelMsg{
		display:flex;
		padding:0.3rem;
		img{
			max-width:1.22rem;
			height:0.9rem;
			margin-right:0.3rem;
		}
		.right{
			.name{
				color:#333333;
				font-size:0.28rem;
			}
			.address{
				font-size:0.22rem;
				i{
					position:relative;
					top:1px;
					left:-1px;
				}
				margin-bottom:0.1rem;
			}
			.desc{
				font-size:0.22rem;
				line-height:0.36rem;
			}
		}
	}
	.text{
		padding:0.3rem;
	}
</style>

<script>
	import pageTitle  from '../../components/pageTitle.vue'
	import inputArea from '../../components/input/inputArea.vue'
	import api from '../../api/index.js'

	export default {
		data () {
			return{
				hintMes: '',
      	toast: false,
				content:'',
				append:''
			}
		},
		activated(){
			this.append = this.$route.query
			this.content = ''
			console.log(this.append)
		},
		methods:{
			publish(){
				if(this.comments == ''){
					this.hintMes = '请填写追评内容'
					this.showToast()
					return
				}
				var params = new this.URLSearchParam()
				params.append('commentId', this.append.CommentID)
				params.append('content', this.content)
				this.$http.post(api.InsertTopicAppend(), params.toParam()).then((res) => {
					console.log(res)
					this.hintMes = res.Message
					this.showToast()
					var that = this
					setTimeout(function() {
						that.$router.go(-1)
					}, 1200);
				})
			},
			showToast() {
				this.toast = true
				if (this.toastTimer) clearTimeout(this.toastTimer)
				this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
			},
			hideToast() {
				this.toast = false
				if (this.toastTimer) clearTimeout(this.toastTimer)
			},
		},
		components: {
			pageTitle,inputArea
		},
	}
</script>


// WEBPACK FOOTER //
// appendComments.vue?f3befd14